<template>
  <v-container
    style="height: 100%; vertical-align: middle"
    fluid
    class="d-flex align-center justify-center"
  >
    <v-card
      class="pa-4 pb-15 ma-0 rounded-xl text-center"
      width="50%"
      varient="tonal"
      color="#f2f5fa"
      elevation="3"
    >
      <v-card-title class="pa-0 ma-0" style="margin: auto">
        <v-img
          class="img"
          src="/images/logologin.svg"
          width="100"
          alt="no image"
          style="margin: auto"
        ></v-img>
      </v-card-title>
      <v-card-text class="pa-5 ma-0">
        <h3
          style="
            color: #ddb303;
            font-size: 40;
            font-family: Tajawal;
            font-weight: bold;
          "
        >
          تسجيل الدخول
        </h3>
      </v-card-text>
      <v-form style="width: 80%; margin: auto" class="fill-height">
        <v-text-field
          variant="outlined"
          color="#ddb303"
          rounded
          v-model="email"
          :label="$t('email')"
          clearable
        ></v-text-field>
        <v-text-field
          variant="outlined"
          color="#ddb303"
          rounded
          v-model="password"
          :label="$t('password')"
          password
          clearable
          :type="showPassword ? 'text' : 'password'"
          :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
        ></v-text-field>
        <v-btn
          @click="login"
          color="#163161"
          rounded
          block
          style="font-family: Tajawal; font-size: 22; font-weight: bold"
          >{{ $t("login") }}</v-btn
        >
      </v-form></v-card
    >
  </v-container>
  <overlay-loader v-model="dialogLoader" />
</template>
<script>
import auth from "@/store/auth.js";
import swal from "sweetalert";
import OverlayLoader from "@/components/common/OverlayLoader.vue";
export default {
  name: "LoginView",
  components: {
    OverlayLoader,
  },
  data() {
    return {
      dialogLoader: false,
      email: "",
      password: "",
      showPassword: false,
    };
  },
  computed: {
    logged() {
      return this.$store.getters.userLoggedIn;
    },
    error() {
      return this.$store.getters.getError;
    },
  },
  methods: {
    async login() {
      if (auth.isLogged()) {
        swal("already logged in");
      } else {
        this.dialogLoader = true;
        const user = await auth.login(this.email, this.password);
        console.log("user", user);
        if (user === null) {
          this.dialogLoader = false;
          swal("error login!!!");
        } else {
          if (user.roles.includes("superadmin")) {
            this.$router.push("/");
          } else if (user.roles.includes("admin")) {
            this.$router.push("/");
          } else if (user.roles.includes("accountant")) {
            this.$router.push("/acc");
          }
        }
      }
    },
  },
};
</script>
